var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgStarOutline = function SvgStarOutline(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillRule: "evenodd",
    d: "m15.62 8.289-2.974-5.893a.728.728 0 0 0-1.296 0l-2.97 5.89-5.724.566a.716.716 0 0 0-.444 1.222l4.714 4.67-1.746 6.344a.723.723 0 0 0 1.023.831l5.795-2.87 5.803 2.874a.723.723 0 0 0 1.023-.831l-1.747-6.345 4.711-4.67a.715.715 0 0 0-.444-1.221zm1.296 11.522-1.285-4.666a1.5 1.5 0 0 1 .39-1.463l3.527-3.497-4.076-.403a1.5 1.5 0 0 1-1.191-.817l-2.283-4.523L9.72 8.961a1.5 1.5 0 0 1-1.192.817l-4.076.404 3.53 3.496a1.5 1.5 0 0 1 .39 1.463l-1.284 4.666 4.244-2.102a1.5 1.5 0 0 1 1.332 0zM2.78 10.347h.012zm17.95-1.334.001-.001",
    clipRule: "evenodd"
  })));
};
export default SvgStarOutline;